import GenericBoostModal from "./generic-boost-modal";
import { GetURLParameter } from "./helpers";

jQuery(document).ready(function ($) {
    // no sense loading all this if we aren't on a detail page
    if (window.location.toString().includes("/detail/")) {
        function toMonthName(zeroBasedMonthIndex) {
            const date = new Date();
            date.setMonth(zeroBasedMonthIndex);
            return date.toLocaleString("en-US", {
                month: "long",
            });
        }

        function displayLoading($container) {
            const content =
                '<div class="loading-holder">' +
                '<img src="/homespotter/darwin/images/loading.svg" width="60" height="45" alt="Loading...">' +
                "</div>";
            $container.html(content);
        }

        function displayPurchaseError($container) {
            const content =
                "<div>Oops, there was a problem with your purchase. If the problem persists reach out to us.</div>";
            $container.html(content);
        }

        function getForm() {
            return $(`.${namespacePrefix}__yuleave`);
        }

        function getFormData() {
            return getForm().serializeArray();
        }

        const namespacePrefix = "agent-promo-edit-campaign-modal";

        const closeHandler = `.${namespacePrefix}__close--js`;
        const activeHandler = `${namespacePrefix}--active`;
        const bgHandler = `${namespacePrefix}__bg`;

        const AgentPromoEndSubscriptionModal = new GenericBoostModal(
            ".launch-agent-promo-edit-modal-parent--js",
            `.launch-agent-promo-edit-modal--js`,
            `.${namespacePrefix}--js`,
            closeHandler,
            activeHandler,
            bgHandler
        );

        const AgentPromoEndSubscriptionReasonModal = new GenericBoostModal(
            `.${namespacePrefix}`,
            ".launch-agent-promo-cancel-reason-modal--js",
            `.${namespacePrefix}__reason-modal`,
            closeHandler,
            activeHandler,
            bgHandler
        );

        const AgentPromoEndSubscriptionBy2Get1PromptModal =
            new GenericBoostModal(
                `.${namespacePrefix}`,
                `.${namespacePrefix}__launch-buy2get1-modal--js`,
                `.${namespacePrefix}__buy2get1-modal`,
                closeHandler,
                activeHandler,
                bgHandler,
                null,
                false
            );

        const AgentPromoEndSubscriptionBy2Get1ReceiptModal =
            new GenericBoostModal(
                `.${namespacePrefix}`,
                `.${namespacePrefix}__launch-buy2get1-receipt--js`,
                `.${namespacePrefix}__buy2get1-receipt-modal`,
                closeHandler,
                activeHandler,
                bgHandler,
                () => {
                    AgentPromoEndSubscriptionBy2Get1ReceiptModal.ignoreCloseRequests = true;

                    const contentHandler = jQuery(
                        `.${namespacePrefix}__buy2get1-receipt-content--js`
                    );

                    const shortcode = $("[name=shortcode]").val();
                    const campaignId = $("[name=campaignId]").val();
                    const endpoint = `/dashboard/boost/handle_promo_subscription_buy2get1_credit/${shortcode}/${campaignId}`;

                    displayLoading(contentHandler);

                    jQuery
                        .post(endpoint, getFormData())
                        .success(function (response) {
                            const {
                                success,
                                expectedNextPayment,
                                orderConfirmationNumber,
                                savingsDollars,
                            } = jQuery.parseJSON(response);

                            AgentPromoEndSubscriptionBy2Get1ReceiptModal.ignoreCloseRequests = false;

                            if (!success) {
                                displayPurchaseError(contentHandler);
                                return;
                            }

                            const nextPaymentDate = new Date(
                                expectedNextPayment
                            );
                            const monthIndexOfNextPayment =
                                nextPaymentDate.getMonth();
                            const freeMonthIndex =
                                monthIndexOfNextPayment === 0
                                    ? 11
                                    : monthIndexOfNextPayment - 1;
                            const freeMonth = toMonthName(freeMonthIndex);
                            const monthOfNextPayment = toMonthName(
                                monthIndexOfNextPayment
                            ).toUpperCase();
                            const dayOfNextPayment = nextPaymentDate.getDate();

                            let content = `<div class="${namespacePrefix}__primary-copy ${namespacePrefix}__left"><p>Fantastic</p></div>`;
                            content += `<div class="${namespacePrefix}__details ${namespacePrefix}__left">`;
                            content += `<p>We’ve adjusted your account.</p>`;
                            content += `<p>Your next billing date is: <b>${monthOfNextPayment} ${dayOfNextPayment}</b></p>`;
                            content += `<p>Order #: ${orderConfirmationNumber}</p>`;
                            content += `<p><b>You saved</b> $${savingsDollars} for ${freeMonth}</p></div>`;
                            content += `<div class="${namespacePrefix}__footer ${namespacePrefix}__center">`;
                            content += `<a href="/dashboard/boost/all/${shortcode}" class="${namespacePrefix}__button">Return to dashboard</a></div>`;

                            contentHandler.html(content);
                        })
                        .fail(function () {
                            AgentPromoEndSubscriptionBy2Get1ReceiptModal.ignoreCloseRequests = false;
                            displayPurchaseError(contentHandler);
                        });
                },
                false
            );

        const AgentPromoEndSubscriptionConfirmationModal =
            new GenericBoostModal(
                `.${namespacePrefix}`,
                `.${namespacePrefix}__never-to-be-found--js`,
                `.${namespacePrefix}__unsubscribe-confirmation-modal`,
                closeHandler,
                activeHandler,
                bgHandler,
                null,
                false
            );
        const showCancelSuccessModal = GetURLParameter(
            "show_cancel_success_modal"
        );
        if (showCancelSuccessModal == 1) {
            AgentPromoEndSubscriptionConfirmationModal.open();
        }

        // handle flow control determined by selecting certain radio buttons
        const isEligibleForPromoBuy2Get1Extension = $(
            "[name=isEligibleForPromoBuy2Get1Extension]"
        ).val();
        const $reasonFooterButtonsContainer = $(
            `.${namespacePrefix}__reason-modal .${namespacePrefix}__footer`
        );
        $reasonFooterButtonsContainer.hide();
        const $cancelFormSubmit = $(
            `a.${namespacePrefix}__submit-cancel-button--js`
        );
        const promoForYouClass = `${namespacePrefix}__launch-buy2get1-modal--js`;
        const unsubscribeForRealButtonClass = `${namespacePrefix}__unsubscribe-for-real-button--js`;
        $("input[type=radio][name=cancel_reason]").change(function () {
            $reasonFooterButtonsContainer.show();
            if (
                isEligibleForPromoBuy2Get1Extension &&
                this.value !== "no_longer_an_agent"
            ) {
                $cancelFormSubmit.removeClass(unsubscribeForRealButtonClass);
                $cancelFormSubmit.addClass(promoForYouClass);
            } else {
                $cancelFormSubmit.removeClass(promoForYouClass);
                $cancelFormSubmit.addClass(unsubscribeForRealButtonClass);
            }
        });
        // wait for some input before showing submit/unsubscribe button
        $(
            `.${namespacePrefix}__reason-modal .${namespacePrefix}__textarea`
        ).click(function () {
            $reasonFooterButtonsContainer.show();
        });

        // handle clicks to actually unsubscribe
        $(`.${namespacePrefix}`).on(
            "click",
            `.${unsubscribeForRealButtonClass}`,
            function (e) {
                e.preventDefault();
                AgentPromoEndSubscriptionReasonModal.ignoreCloseRequests = true;
                AgentPromoEndSubscriptionBy2Get1PromptModal.ignoreCloseRequests = true;

                const disabledClass = "disabled";
                // make sure they don't try to click redeem after trying to cancel
                $(`.${namespacePrefix}__launch-buy2get1-receipt--js`).attr(
                    disabledClass,
                    disabledClass
                );
                $(this).off();
                const form = getForm();
                if (!form.hasClass(disabledClass)) {
                    form.addClass(disabledClass);
                    form.submit();
                }
            }
        );
    }

});
